import { MouseEventHandler, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { SubtitleSurveyLabel } from "theme/survey";
import { SelectGender } from "theme/theme";
import { Options } from "views/raffles/types";

export interface DropDownProps {
  title: string;
  items?: Options[];
  onChange: (key: string, selected: string[]) => void;
}

const DropDown = (props: DropDownProps) => {
  const [selected, setSelected] = useState<string[]>([]);
  const { register } = useForm()
  const titleRef = useRef<HTMLHeadingElement>(null);

  const onChange: MouseEventHandler<HTMLSelectElement> = (event) => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'SURVEY - Seleccionar encuesta', value: '10' })
    const itemId = event.currentTarget.value as string;
    if (itemId === 'SELECCIONA UNA RESPUESTA') return setSelected([]);
    return setSelected([itemId]);
  };

  useEffect(() => {
    props.onChange(titleRef.current?.innerText.replace("\n", " ").toLocaleLowerCase() || "", selected);
  }, [selected, titleRef]);

  return (
    <>
      <div className="p-2 w-full">
        <SubtitleSurveyLabel className="font-black text-2xl text-center md:text-3xl" ref={titleRef}>
          {props.title}
        </SubtitleSurveyLabel>
      </div>
      <div className={`justify-center my-2 gap-2 md:mx-auto w-full text-black`}>
        <SelectGender className="w-full h-16 px-4 dinPro text-sm font-medium" {...register(props.title, { onChange: onChange })}>
          <option value={null}>SELECCIONA UNA RESPUESTA</option>
          {props.items &&
            props.items.map(({ id, option }) => {
              return (
                <option
                  key={id}
                  className="aspect-square flex items-end relative"
                  id={String(id)}
                  value={String(id)}
                  data-kind={id}
                >
                  {option}
                </option>
              );
            })}
        </SelectGender>
      </div>
    </>
  );
};

export default DropDown;
